import React from "react";
import styled from "styled-components";
import { Size } from "@themes/Device";

const Root = styled.div`
    height: 100dvh;
    width: 100vw;
    flex-direction: row;
    display: grid;
    grid-template-columns: 1fr 1fr;
    overflow-y: scroll;

    @media (max-width: ${Size.laptop}) {
        grid-template-columns: 1fr;
    }
`;

const LeftSplit = styled.div<{ gradientBackground?: boolean }>`
    min-width: 0;
    justify-self: stretch;
    align-self: stretch;
`;

const RightSplit = styled.div`
    min-width: 0;
    justify-self: stretch;
    align-self: stretch;

    @media (max-width: ${Size.laptop}) {
        display: none;
    }
`;

type SplitLayoutProps = {
    left: React.ReactNode;
    right: React.ReactNode;
} & React.ComponentPropsWithoutRef<"div">;

export function SplitLayout(props: SplitLayoutProps) {
    const { left, right, ...forwardedProps } = props;
    return (
        <Root {...forwardedProps}>
            <LeftSplit>{props.left}</LeftSplit>
            <RightSplit>{props.right}</RightSplit>
        </Root>
    );
}
